import React from "react";
import {
  Input,
  Button,
  MaskedInput,
} from "@dreambigger/design-system/src/components";
import { Row, Form } from "antd";
import { ArrowRightOutlined } from "@ant-design/icons";
import { RefObject } from "react";

export type LoginFormProps = {
  form: any;
  loginMode: "email" | "sms";
  keyByLoginMode: string;
  formattedCred: any;
  loginTitle?: string;
  loginPlaceholder?: string;
  submitButtonText?: string;
  emailInputRef: RefObject<any>;
  phoneInputRef: RefObject<any>;
  onFinish: (values: any) => void;
  isAdminMode?: boolean;
  className?: string;
  inputClassName?: string;
  inputStyle?: React.CSSProperties;
  buttonClassName?: string;
  buttonStyle?: React.CSSProperties;
  layout?: "horizontal" | "vertical";
};

export default function LoginForm({
  form,
  loginMode,
  keyByLoginMode,
  formattedCred,
  loginTitle,
  loginPlaceholder,
  submitButtonText,
  emailInputRef,
  phoneInputRef,
  onFinish,
  isAdminMode = false,
  className = "mt-5 flex flex-column items-center md_items-start",
  inputClassName = "br-5 pv-3 mt-3 md_mt-0",
  inputStyle = { borderColor: "black", width: "332px" },
  buttonClassName = "lift h-8 ph-6",
  buttonStyle,
}: LoginFormProps) {
  return (
    <Form
      form={form}
      className={className}
      initialValues={{ [keyByLoginMode]: formattedCred }}
      onFinish={onFinish}
    >
      <label
        className="primary fwb f-6 lg_f-4 xl_f-5 xxl_f-6 md_mb-2"
        dangerouslySetInnerHTML={{
          __html: loginTitle ?? "",
        }}
      />
      <Row
        align="bottom"
        className="lg_mb-8 fwb justify-center lg_justify-start"
      >
        <Form.Item name={keyByLoginMode} style={{ paddingRight: "8px" }}>
          {loginMode === "email" ? (
            <Input
              className={`${inputClassName} ${
                isAdminMode && "disabled notAllowed"
              }`}
              style={inputStyle}
              placeholder={loginPlaceholder || "Enter your email"}
              type="email"
              ref={emailInputRef}
              readOnly={isAdminMode}
              required
            />
          ) : (
            <MaskedInput
              className={`${inputClassName} ${
                isAdminMode && "disabled notAllowed"
              }`}
              style={inputStyle}
              placeholder={loginPlaceholder || "Enter your phone number"}
              mask="(000) 000-0000"
              name="phone"
              ref={phoneInputRef}
              readOnly={isAdminMode}
            />
          )}
        </Form.Item>

        <div
          className="min-w-20"
          style={{ paddingLeft: "8px", paddingRight: "8px" }}
        >
          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              className={buttonClassName}
              style={buttonStyle}
            >
              {submitButtonText || "Submit"} <ArrowRightOutlined />
            </Button>
          </Form.Item>
        </div>
      </Row>
    </Form>
  );
}
